import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { remarkUnderline } from './remarkUnderline';

const schema = {
  ...defaultSchema,
  tagNames: [...defaultSchema.tagNames, 'u'],
};

export const markdownPreviewOptions = {
  remarkPlugins: [remarkUnderline],
  rehypePlugins: [[rehypeSanitize, schema]],
};
